<template>
  <div class="container">
    <item-10000
      @number10000-value="showNumber10000"
      ref="tenThousands"
    ></item-10000>
    <item-1000 @number1000-value="showNumber1000" ref="oneThousand"></item-1000>
    <item-100 @number100-value="showNumber100" ref="oneHundred"></item-100>
  </div>
  <p
    :class="{
      blurred: shouldHideNumbers,
      revealable: canRevealNumber,
    }"
    :role="canRevealNumber ? 'button' : undefined"
    :tabindex="canRevealNumber ? 0 : -1"
    :aria-hidden="shouldHideNumbers && !canRevealNumber"
    :aria-label="canRevealNumber ? 'Odsłoń ukryty kod' : undefined"
    @click="revealNumber"
    @keydown.enter.prevent="revealNumber"
    @keydown.space.prevent="revealNumber"
  >
    <span :aria-hidden="shouldHideNumbers">
      {{ number10000 }} {{ number1000 }} {{ number100 }}
    </span>
  </p>
</template>

<script>
import item100 from './item100.vue';
import item1000 from './item1000.vue';
import item10000 from './item10000.vue';

export default {
  props: {
    forceHidden: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    item100,
    item1000,
    item10000,
  },
  data() {
    return {
      number100: null,
      number1000: null,
      number10000: null,
      numbersAreHidden: true,
    };
  },
  emits: ['number-value'],
  computed: {
    shouldHideNumbers() {
      return this.numbersAreHidden || this.forceHidden;
    },
    rowValue() {
      if (
        this.number100 === null ||
        this.number1000 === null ||
        this.number10000 === null
      ) {
        return null;
      }

      return `${this.number10000}${this.number1000}${this.number100}`;
    },
    canRevealNumber() {
      return this.numbersAreHidden && !this.forceHidden;
    },
  },
  watch: {
    rowValue(value) {
      if (value !== null) {
        this.$emit('number-value', value);
      }
    },
  },
  methods: {
    showNumber100(dozens) {
      this.number100 = dozens;
    },
    showNumber1000(thousands) {
      this.number1000 = thousands;
    },

    showNumber10000(thousandsX10) {
      this.number10000 = thousandsX10;
    },
    randomizeRow() {
      this.$refs.tenThousands.random10000();
      this.$refs.oneThousand.randomColor();
      this.$refs.oneHundred.random100();
    },
    toggleNumbers() {
      this.numbersAreHidden = !this.numbersAreHidden;
    },
    revealNumber() {
      if (this.canRevealNumber) {
        this.numbersAreHidden = false;
      }
    },

    // getRandomNumber(maxNumber) {
    //   return Math.floor(Math.random() * maxNumber);
    // },
    // randomPrzestrzen() {
    //   this.przestrzenNo = getRandomNumber(10);
    //   console.log(this.przestrzenNo);
    // },
    // randomColor() {
    //   this.colorNo = getRandomNumber(10);
    //   this.colorName = this.cssColorNames[this.colorNo];
    //   console.log(this.colorName);
    //   console.log(this.colorNo);
    // },
    // randomZdjecie() {
    //   this.zdjecieNo = getRandomNumber(100).toString().padStart(2, '0');
    //   console.log(this.zdjecieNo);
    // },
    // randomAll() {
    //   console.log('randomAll');
    //   this.przestrzenNo = getRandomNumber(10);
    //   this.colorNo = getRandomNumber(10);
    //   this.colorName = this.cssColorNames[this.colorNo];
    //   this.zdjecieNo = getRandomNumber(100).toString().padStart(2, '0');
    // },
  },
};

// let getRandomNumber = function (maxNumber) {
//   return Math.floor(Math.random() * maxNumber);
// };
</script>

<style scoped>
.kwadrat {
  height: var(--squareSize);
  width: var(--squareSize);
  min-width: 0;
  border: 0;
  padding: 0;
  overflow: hidden;
  background: transparent;
  cursor: pointer;
}

.kwadrat:focus-visible {
  outline: 3px solid #fff;
  outline-offset: 3px;
}

:deep(.kwadrat img) {
  height: var(--squareSize);
  width: var(--squareSize);
  display: block;
  object-fit: cover;
}

p {
  text-align: center;
  justify-content: center;
  color: rgb(133, 149, 163);
  font-size: 0.8rem;
  display: flex;
  width: 100%;
  height: 15px;
}

.revealable {
  cursor: pointer;
}

.revealable:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 4px;
}

.container {
  --squareSize: clamp(76px, 27vw, 115px);
  display: flex;
  justify-content: center;
  flex-direction: row;
  background-color: rgb(10, 10, 10);
  margin-bottom: 7px;
  margin-top: 15px;
}

@media (max-width: 320px) {
  .container {
    --squareSize: 31vw;
  }
}
</style>
